<template>
	<svg
		width="17"
		height="17"
		viewBox="0 0 17 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.1732 7.16623L11.9969 5.1284C11.9473 5.1036 11.9218 5.05331 11.8963 5.00302L9.83371 0.826767C9.48096 0.0971971 8.57573 -0.205256 7.84545 0.146779C7.5497 0.291584 7.31067 0.530863 7.16617 0.826767L5.10354 5.00302C5.07607 5.04933 5.04221 5.09153 5.00296 5.1284L0.826706 7.19173C0.097136 7.54377 -0.205317 8.44971 0.146718 9.17928C0.291839 9.47498 0.531006 9.71415 0.826706 9.85927L5.00296 11.8964C5.05254 11.9219 5.07804 11.9722 5.10354 11.997L7.19167 16.1732C7.54371 16.9028 8.44965 17.2053 9.17922 16.8532C9.47497 16.7084 9.714 16.4691 9.8585 16.1732L11.8963 11.997C11.9218 11.9474 11.9721 11.8964 11.9969 11.8964L16.1732 9.83377C16.9027 9.48102 17.2052 8.57579 16.8532 7.84622C16.7271 7.54377 16.4756 7.31781 16.1732 7.16623ZM13.0792 7.46869L11.142 9.15449C10.7644 9.50652 10.4875 9.95914 10.3869 10.4628L9.884 12.978C9.8585 13.0793 9.75792 13.1551 9.65733 13.1296C9.60704 13.1296 9.58154 13.1041 9.55675 13.0538L7.87095 11.1165C7.51892 10.739 7.06559 10.4628 6.56268 10.3615L4.04673 9.85856C3.94615 9.83377 3.87036 9.73248 3.89586 9.6319C3.89586 9.58231 3.92065 9.55681 3.97094 9.53131L5.9082 7.84551C6.28573 7.49348 6.56268 7.04086 6.66326 6.53725L7.16617 4.022C7.19167 3.92071 7.29225 3.84492 7.39284 3.87042C7.43064 3.87672 7.46569 3.89425 7.49342 3.92071L9.17922 5.85797C9.53125 6.2355 9.98458 6.51245 10.4875 6.61304L13.0034 7.11594C13.104 7.14144 13.1798 7.24202 13.1543 7.34261C13.1414 7.39077 13.1155 7.43442 13.0792 7.46869Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "ManaIcon",
};
</script>
